import { Box, Button, CircularProgress, Grid2, Modal, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { viewPDF } from "../../../utils/viewPDF";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ErrorModal from "../../../utils/ErrorModal";
import html2pdf from "html2pdf.js";
import { handleExportPDF } from "../../../utils/exportToPDF";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Preview = ({ rfq, setStep, bid, data, user, fileNames }) => {
  const navigate = useNavigate();
  const [currency, setCurrency] = useState();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const { rfqId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [msg, setMsg] = useState();
  const [draft, setDraft] = useState();
  const pdfRef = useRef();
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    const getCurrency = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-currency?rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setCurrency(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getCurrency();
  }, []);

  useEffect(() => {
    const getDraft = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-bid?vendorId=${vendorId}&rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setDraft(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    getDraft();
  }, []);

  const groupedWorkItems = data.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = [];
    }
    acc[item.section].push(item);
    return acc;
  }, {});

  const handleNext = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const indexedData = data.map((item, index) => ({
        ...item,
        itemOrder: index,
      }));
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/bid`,
        {
          vendorId: vendorId,
          rfqId: rfq.rfqId,
          deliveryTerms: bid?.deliveryTerms || "N/A",
          paymentTerms: bid?.paymentTerms || "N/A",
          freight: bid?.freight || "N/A",
          priceBasis: bid?.priceBasis || "N/A",
          warrantyPeriod: bid?.warrantyPeriod || "N/A",
          deliveryClause: bid?.deliveryClause || "N/A",
          attachment1: bid?.attachment1 || "N/A",
          attachment1Filename: fileNames?.attachment1 || "N/A",
          attachment2: bid?.attachment2 || "N/A",
          attachment2Filename: fileNames?.attachment2 || "N/A",
          attachment3: bid?.attachment3 || "N/A",
          attachment3Filename: fileNames?.attachment3 || "N/A",
          bidWorkItems: indexedData,
        },
        {
          headers: { Authorization: `Bearer ${user.accessToken}` },
        }
      );
      // await axios.delete(
      //   `${process.env.REACT_APP_BACKEND_URL}/draft-bid?draftBidId=${draft.draftBidId}`,
      //   { headers: { Authorization: `Bearer ${user.accessToken}` } }
      // );
      navigate("/vendor/dashboard");
    } catch (error) {
      setOpenError(true);
      setMsg(error?.response?.data?.Exception || "Interal Server Error");
    } finally {
      setLoading(false);
    }
  };

  const grandTotalsByCurrency = data.reduce((acc, row) => {
    const shortform =
      typeof row.currency === "string" ? row.currency : row.currency?.shortform;

    if (!shortform) return acc;

    const currencyObj = currency?.find(
      (c) => c.currency.shortform === shortform
    );

    const symbol = currencyObj?.currency?.symbol || shortform;

    if (!acc[shortform]) {
      acc[shortform] = { symbol, total: 0 };
    }

    acc[shortform].total += parseFloat(row.total);

    return acc;
  }, {});

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };
  return (
    <div style={{ position: "relative" }}>
      {exporting && (
        <div className="uploading-div">
          Exporting PDF... This may take a while. <CircularProgress color="#fff" />
        </div>
      )}
      {loading && <div className="loading-div uploading-div">Submitting Quote... <CircularProgress color="#fff" /></div>}
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true);
              await handleExportPDF(pdfRef, "Quote_Details");
            } catch (error) {
              console.log(error);
            } finally {
              setExporting(false);
            }
          }}
        >
          Export PDF
        </Button>
      </div>
      <h2>Quotation Submission Review</h2>
      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10}>
          <Grid2 container>
            {rfq && rfq.term1 && (
              <>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderTop: "1px solid #000" }}
                >
                  Delivery period (Lead Time)
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{
                    borderTop: "1px solid #000",
                    borderRight: "1px solid #000",
                  }}
                >
                  {bid && bid.deliveryTerms}
                </Grid2>
              </>
            )}
            {rfq && rfq.term2 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Payment Terms
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.paymentTerms}
                </Grid2>
              </>
            )}
            {rfq && rfq.term3 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Freight
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.freight}
                </Grid2>
              </>
            )}
            {rfq && rfq.term4 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Price Basis (Incoterms)
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.priceBasis}
                </Grid2>
              </>
            )}
            {rfq && rfq.term5 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Warranty Period
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.warrantyPeriod}
                </Grid2>
              </>
            )}
            {rfq && rfq.term6 && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Delivery Clause
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {bid && bid.deliveryClause}
                </Grid2>
              </>
            )}
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Attachment 1
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {bid && bid.attachment1 && bid.attachment1 !== "N/A" ? (
                <Button
                  sx={{
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(bid.attachment1, user)}
                >
                  {fileNames.attachment1}
                </Button>
              ) : (
                <Typography fontSize={"14px"}>N/A</Typography>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Attachment 2
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {bid && bid.attachment2 && bid.attachment2 !== "N/A" ? (
                <Button
                  sx={{
                    padding: "0 !important",
                    width: "auto !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(bid.attachment2, user)}
                >
                  {fileNames.attachment2}
                </Button>
              ) : (
                <Typography fontSize={"14px"}>N/A</Typography>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Attachment 3
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {bid && bid.attachment3 && bid.attachment3 !== "N/A" ? (
                <Button
                  sx={{
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(bid.attachment3, user)}
                >
                  {fileNames.attachment3}
                </Button>
              ) : (
                <Typography fontSize={"14px"}>N/A</Typography>
              )}
            </Grid2>
          </Grid2>
        </Box>

        <Box className="dashboard-container" px={10}>
          <Typography className="form-title">Work Item Details</Typography>
          <table
            border={1}
            style={{
              borderCollapse: "collapse",
              width: "100%",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr>
                <th style={{ padding: "20px" }}>Item Code</th>
                <th>Description</th>
                <th>Item Group</th>
                <th>UOM</th>
                <th>Quantity</th>
                <th>Currency</th>
                <th>Rate</th>
                <th>GST(in %)</th>
                <th>Remark</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {groupedWorkItems &&
                Object.entries(groupedWorkItems).map(
                  ([section, items], sectionIndex) => {
                    const sectionTotal = items
                      .reduce((acc, item) => acc + parseFloat(item.total), 0)
                      .toFixed(2);
                    return (
                      <React.Fragment key={sectionIndex}>
                        <tr
                          style={{
                            backgroundColor: "#d9edf7",
                            fontWeight: "bold",
                          }}
                        >
                          <td
                            colSpan={9}
                            style={{ textAlign: "left", padding: "10px" }}
                          >
                            {section}
                          </td>
                          <td style={{ textAlign: "center", padding: "10px" }}>
                            {sectionTotal &&
                              new Intl.NumberFormat("en-IN", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(sectionTotal)}
                          </td>
                        </tr>
                        {items
                          .sort((a, b) => a.itemOrder - b.itemOrder)
                          .map((item, index) => (
                            <tr key={index} style={{ textAlign: "center" }}>
                              <td style={{ padding: "20px" }}>{item.code}</td>
                              <td>{item.description}</td>
                              <td>{item.section}</td>
                              <td>{item.unit}</td>
                              <td>{item.quantity}</td>
                              <td>{item.currency}</td>
                              <td>
                                {new Intl.NumberFormat("en-IN", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(item.rate)}
                              </td>
                              <td>{item.gst}</td>
                              <td
                                style={{
                                  maxWidth: "200px",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.remark}
                              </td>
                              <td>
                                {new Intl.NumberFormat("en-IN", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(item.total)}
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    );
                  }
                )}
              {Object.entries(grandTotalsByCurrency).map(
                ([shortform, { symbol, total }]) => (
                  <tr
                    key={shortform}
                    style={{ backgroundColor: "#d8e9f0", fontWeight: "bold" }}
                  >
                    <td
                      colSpan={9}
                      style={{ textAlign: "right", padding: "20px" }}
                    >
                      Grand Total (of {symbol}):
                    </td>
                    <td style={{ width: "150px", textAlign: "center" }}>
                      {new Intl.NumberFormat("en-IN", {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(total)}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </Box>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={() => setOpen(true)}>
          Submit
        </Button>
      </Box>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to submit these details?
          </Typography>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={() => setOpen(false)}
            >
              No
            </Button>
            <Button
              className="btn-contained"
              onClick={handleNext}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <ErrorModal
        open={openError}
        handleClose={() => setOpenError(false)}
        msg={msg}
      />
    </div>
  );
};

export default Preview;